import { render, staticRenderFns } from "./Leaderboard_List.vue?vue&type=template&id=616cd738&"
import script from "./Leaderboard_List.vue?vue&type=script&lang=js&"
export * from "./Leaderboard_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports